/* Calunar Rechtsseiten: Inhaltsverzeichnis aus den Ueberschriften des Textes,
   Markierung des gerade gelesenen Abschnitts, Drucken.

   Der Text kommt als fertiges HTML aus der Shopify-Richtlinie. Das Verzeichnis
   entsteht deshalb hier und nicht im Liquid. Ohne JavaScript bleibt es
   ausgeblendet und die Seite ist trotzdem vollstaendig lesbar. */

(() => {
  const MIN_EINTRAEGE = 3;
  const DESKTOP = '(min-width: 990px)';

  const slug = (text, vergeben) => {
    const basis = text
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'abschnitt';
    let kandidat = basis;
    let zaehler = 2;
    while (vergeben.has(kandidat) || document.getElementById(kandidat)) {
      kandidat = `${basis}-${zaehler}`;
      zaehler += 1;
    }
    vergeben.add(kandidat);
    return kandidat;
  };

  const versteckeDoppeltenTitel = (wurzel, text) => {
    const titel = wurzel.querySelector('.cal-recht__h1');
    const erste = text.firstElementChild;
    if (!titel || !erste || !/^H[12]$/.test(erste.tagName)) return;
    // Richtlinien aus calunar-rechtstexte beginnen immer mit ihrem Titel, auch wenn
    // die Page kuerzer heisst ("AGB"). Bei freiem Seiteninhalt nur bei gleichem Wortlaut.
    const ausRichtlinie = text.dataset.calRechtQuelle === 'richtlinie';
    const gleich = erste.textContent.trim().toLowerCase() === titel.textContent.trim().toLowerCase();
    if (ausRichtlinie || gleich) erste.setAttribute('data-cal-recht-doppelt', '');
  };

  const sammleUeberschriften = (text) => {
    const sichtbar = (h) => !h.hasAttribute('data-cal-recht-doppelt');
    const h3 = [...text.querySelectorAll('h3')].filter(sichtbar);
    if (h3.length >= MIN_EINTRAEGE) return h3;
    return [...text.querySelectorAll('h2')].filter(sichtbar);
  };

  const baueVerzeichnis = (wurzel, ueberschriften) => {
    const nav = wurzel.querySelector('[data-cal-recht-inhalt]');
    const liste = wurzel.querySelector('[data-cal-recht-liste]');
    const klappe = wurzel.querySelector('[data-cal-recht-klapp]');
    if (!nav || !liste || ueberschriften.length < MIN_EINTRAEGE) return [];

    const vergeben = new Set();
    const links = ueberschriften.map((ueberschrift) => {
      if (!ueberschrift.id) ueberschrift.id = slug(ueberschrift.textContent, vergeben);
      const link = document.createElement('a');
      link.href = `#${ueberschrift.id}`;
      link.textContent = ueberschrift.textContent.trim();
      const eintrag = document.createElement('li');
      eintrag.append(link);
      liste.append(eintrag);
      return link;
    });

    const breit = window.matchMedia(DESKTOP);
    const stelleKlappe = () => { if (klappe) klappe.open = breit.matches; };
    stelleKlappe();
    breit.addEventListener('change', stelleKlappe);

    // Mobil klappt das Verzeichnis nach der Wahl wieder zu, sonst verdeckt es das Ziel.
    liste.addEventListener('click', (klick) => {
      if (klick.target.closest('a') && klappe && !breit.matches) klappe.open = false;
    });

    nav.hidden = false;
    return links;
  };

  const markiereAktuellen = (ueberschriften, links) => {
    if (!('IntersectionObserver' in window) || links.length === 0) return;
    const linkZu = new Map(ueberschriften.map((ueberschrift, i) => [ueberschrift, links[i]]));

    const setze = (aktiv) => {
      links.forEach((link) => link.removeAttribute('aria-current'));
      if (aktiv) aktiv.setAttribute('aria-current', 'true');
    };

    const beobachter = new IntersectionObserver((eintraege) => {
      const sichtbare = eintraege.filter((eintrag) => eintrag.isIntersecting);
      if (sichtbare.length === 0) return;
      const oberste = sichtbare.reduce((a, b) => (a.boundingClientRect.top < b.boundingClientRect.top ? a : b));
      setze(linkZu.get(oberste.target));
    }, { rootMargin: '-20% 0px -65% 0px' });

    ueberschriften.forEach((ueberschrift) => beobachter.observe(ueberschrift));
  };

  const starte = () => {
    document.querySelectorAll('[data-cal-recht]').forEach((wurzel) => {
      const drucken = wurzel.querySelector('[data-cal-recht-drucken]');
      if (drucken) drucken.addEventListener('click', () => window.print());

      const text = wurzel.querySelector('[data-cal-recht-text]');
      if (!text) return;

      versteckeDoppeltenTitel(wurzel, text);
      const ueberschriften = sammleUeberschriften(text);
      const links = baueVerzeichnis(wurzel, ueberschriften);
      markiereAktuellen(ueberschriften, links);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starte);
  } else {
    starte();
  }
})();
